// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15qZb","badges":"styles_badges__2U8WW"};